import { render, staticRenderFns } from "./SitchModifierGroupConfig.vue?vue&type=template&id=20eee024&scoped=true&"
import script from "./SitchModifierGroupConfig.vue?vue&type=script&lang=ts&"
export * from "./SitchModifierGroupConfig.vue?vue&type=script&lang=ts&"
import style0 from "./SitchModifierGroupConfig.vue?vue&type=style&index=0&id=20eee024&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20eee024",
  null
  
)

export default component.exports